import {Col, Image, Row, Button, Container, Form} from 'react-bootstrap'
import {
  ICON_PETAL,
  ICON_FLOWER,
  ICON_CIRCLE,
  IMAGE_PROFILE,
} from '../../constants/pngs'
import {
  CONTACT_URL,
  SERVICES_URL,
} from '../../constants/urls'
import {localise} from '../../services/LocalizationServices'
import {useNavigate} from 'react-router'
import {Helmet} from 'react-helmet'
import {Swiper, SwiperSlide} from '../../components/swiper'
import {QUOTE_ICON} from '../../constants/svgs'
import Accordion from 'react-bootstrap/Accordion'

/* eslint-disable */

const HomepageView = () => {
  const history = useNavigate()
  const toContactUs = () => {history(CONTACT_URL)}
  const toServices = () => {history(SERVICES_URL)}
    
  const HeaderView = () => (
    <div className='bg-brand-primary pb-xl-5 pb-3 pt-2'>
      <Helmet>
        <meta charSet='utf-8' name='description' content={localise('SEO.homepage.description')}/>
        <meta charSet='utf-8' name='keywords' content={localise('SEO.homepage.keywords')}/>
        <link rel='canonical' href="https://thehypnotherapypractice.ie" />
        <title>{localise('SEO.homepage.title')}</title>
      </Helmet>
      <Container>
        <div className='homepage-hero-section'>
          <div className='pb-lg-5 mt-2 me-lg-5'>
            <div className='custom-text-align homepage-title-style'>
              {localise('homepage.headingTitle')}
            </div>
            <div className='mt-4 pe-lg-5 custom-text-align homepage-title-desc-style'>
              {localise('homepage.headingDesc')}
            </div>
            <div className='mt-4 custom-text-align text-sm-center text-lg-start homepage-detail-style'>
              {localise('homepage.headingMsg')}
            </div>
            <div className='w-100 text-sm-center text-lg-start homepage-connect-btn'>
              <Button
                variant='primary'
                className='font-button-bold d-inline-block mx-auto mt-5 py-3 px-5 homepage-connect-btn'
                onClick={toContactUs}>
                {localise('homepage.topButton')}
              </Button>
            </div>
          </div>
          <div className='w-100'>
            <div className='container px-5 py-5'>
              <img className='circular--portrait' src={IMAGE_PROFILE} ></img>
            </div>
          </div>
        </div>

      </Container>
    </div>
  )

  const IntroView = () => (
    <div className='padding-between-sections'>
      <Container>
        <div>
          <Col className='mb-5'>
            <div className='homepage-about-title text-center'>{localise('homepage.aboutTitle')}</div>
            <div className='w-100 mt-4'>
              <div className='homepage-about-Subheader text-center'>{localise('homepage.aboutHeader')}</div>
            </div>
            <div className='w-100'>
              <div className='homepage-about-normal text-center justify-content-center align-items-center mt-3'>
                {localise('homepage.aboutHeaderDesc')}
              </div>
            </div>
            <Button
                variant=''
                className='btn-secondary font-body-regular d-inline-block mx-auto mt-5 py-3 px-5 homepage-connect-btn'
                onClick={toContactUs}>
                {localise('buttonText.contactMe')}
            </Button>
          </Col>
        </div>
        <Col className='w-100 mt-5' xs={{span: 12, offset: 0}} lg={{span: 2, offset: 0}} xl={{span: 12, offset: 0}}>
          <div className="wrapper-about">
            <Col className='col color-primary col-item'>
              <Image
                className='homepage-benefit-img mb-4'
                src={ICON_FLOWER}
                alt={localise('alt.headerImg')}
              />
              <div className='homepage-benefit-txt'>{localise('homepage.aboutLeft')}</div>
            </Col>
            <Col className='col color-primary col-item'>
              <Image
                className='homepage-benefit-img mb-4'
                src={ICON_CIRCLE}
                alt={localise('alt.headerImg')}
              />
              <div className='homepage-benefit-txt'>{localise('homepage.aboutMiddle')}</div>
            </Col>
            <Col className='col color-primary col-item'>
              <Image
                className='homepage-benefit-img mb-4'
                src={ICON_PETAL}
                alt={localise('alt.headerImg')}
              />
              <div className='homepage-benefit-txt'>{localise('homepage.aboutRight')}</div>
          </Col>
          </div>
        </Col>
      </Container>
    </div>
  )

  const MyServices = () => (
    <div className='padding-between-sections homepage-my-services'>
      <Container>
        <div>
          <Col className='pb-5'>
            <div className='homepage-about-title text-center'>{localise('homepage.myServicesTitle')}</div>
            <div className='homepage-about-Subheader text-center mt-4'>
              {localise('homepage.myServicesTagline')}
            </div>
          </Col>
        </div>
        <Col className='w-100' xs={{span: 12, offset: 0}} lg={{span: 12, offset: 0}} xl={{span: 12, offset: 0}}>
          <div className="wrapper">
            <FlexBoxItem 
              number='0 1 .' 
              title={localise('homepage.myServicesAnxietyTitle')} 
              desc={localise('homepage.myServicesAnxietyDesc')}
            />
            <FlexBoxItem 
              number='0 2 .' 
              title={localise('homepage.myServicesConfidenceTitle')} 
              desc={localise('homepage.myServicesConfidenceDesc')}
            />
            <FlexBoxItem 
              number='0 3 .' 
              title={localise('homepage.myServicesWeightLossTitle')} 
              desc={localise('homepage.myServicesWeightLossDesc')}
            />
            <FlexBoxItem 
              number='0 4 .' 
              title={localise('homepage.myServicesFearsTitle')} 
              desc={localise('homepage.myServicesFearsDesc')}
            />
          </div>
        </Col>
        <Button
          variant=''
          className='btn-secondary font-body-regular d-inline-block mx-auto mt-5 py-3 px-5 homepage-connect-btn'
          onClick={toServices}>
            {localise('buttonText.learnMore')}
        </Button>
      </Container>
    </div>
  )

  const Testimonials = () => (
    <div className='padding-between-sections homepage-testimonials'>
      <div className='quotes-swiper'>
        <Swiper
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }}
          speed={1000}
          loop={true}
          slidesPerView={1}
          centeredSlides={true}>
          <SwiperSlide key={'1'}>
            <div>
              <div className='w-100 mb-4'>
                <Image
                  className='quote-icon'
                  src={QUOTE_ICON}
                  height={60}
                />
              </div>
              <div className='swiper-slide homepage-slider-title'>{localise('homepage.quoteOne')}</div>
              <div className='homepage-slider-detail mt-3'>{localise('homepage.quoteOneName')}</div>
            </div>
          </SwiperSlide>
          <SwiperSlide key={'2'}>
             <div>
              <div className='w-100 mb-4'>
                <Image
                  className='quote-icon'
                  src={QUOTE_ICON}
                  height={60}
                />
              </div>
              <div className='swiper-slide homepage-slider-title'>{localise('homepage.quoteTwo')}</div>
              <div className='homepage-slider-detail mt-3'>{localise('homepage.quoteTwoName')}</div>
            </div>
          </SwiperSlide>
          <SwiperSlide key={'3'}>
               <div>
              <div className='w-100 mb-4'>
                <Image
                  className='quote-icon'
                  src={QUOTE_ICON}
                  height={60}
                />
              </div>
              <div className='swiper-slide homepage-slider-title'>{localise('homepage.quoteThree')}</div>
              <div className='homepage-slider-detail mt-3'>{localise('homepage.quoteThreeName')}</div>
            </div>
          </SwiperSlide>
          <SwiperSlide key={'4'}>
               <div>
              <div className='w-100 mb-4'>
                <Image
                  className='quote-icon'
                  src={QUOTE_ICON}
                  height={60}
                />
              </div>
              <div className='swiper-slide homepage-slider-title'>{localise('homepage.quoteFour')}</div>
              <div className='homepage-slider-detail mt-3'>{localise('homepage.quoteFourName')}</div>
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
      <div className="swiper-pagination"></div>
    </div>
  )

  const FlexBoxItem = ({number, title, desc}) => (
    <div className='homepage-my-service-box'>
      <div className='homepage-my-service-box-title mt-3 mx-3'>
        {number}
      </div>
      <div className='homepage-my-service-box-detail mt-3 mx-3'>
        {title} 
      </div>
      <div className='homepage-detail-text mt-3 mx-3'>
        {desc}
      </div>
    </div>
  )

  const FAQs = () => (
    <div className='padding-between-sections bg-brand-primary'>
      <Container>
        <div>
          <Col className='pb-5'>
            <div className='homepage-about-title text-center'>{localise('homepage.faqsTitle')}</div>
            <div className='homepage-about-Subheader text-center mt-4'>{localise('homepage.faqsTagline')}</div>
          </Col>
        </div>
        <div className='w-100'>
          <div className='d-flex justify-content-center' style={{ flexDirection: "column", position: "relative", textAlign: "center" }}>
            <Accordion className='w-100'>
              <Accordion.Item eventKey="0" className='w-100'>
                <Accordion.Header className='w-100 accordian-title py-2'>{localise('homepage.faqOneTitle')}</Accordion.Header>
                <Accordion.Body className='w-100 accordian-content-bg'>{localise('homepage.faqOneDesc')}</Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="1" className='w-100'>
                <Accordion.Header className='w-100 accordian-title py-2'>{localise('homepage.faqTwoTitle')}</Accordion.Header>
                <Accordion.Body className='w-100 accordian-content-bg'>{localise('homepage.faqTwoDesc')}</Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="2" className='w-100'>
                <Accordion.Header className='w-100 accordian-title py-2'>{localise('homepage.faqThreeTitle')}</Accordion.Header>
                <Accordion.Body className='w-100 accordian-content-bg'>{localise('homepage.faqThreeDesc')}</Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="3" className='w-100'>
                <Accordion.Header className='w-100 accordian-title py-2'>{localise('homepage.faqFourTitle')}</Accordion.Header>
                <Accordion.Body className='w-100 accordian-content-bg'>{localise('homepage.faqFourDesc')}</Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="4" className='w-100'>
                <Accordion.Header className='w-100 accordian-title py-2'>{localise('homepage.faqFiveTitle')}</Accordion.Header>
                <Accordion.Body className='w-100 accordian-content-bg'>{localise('homepage.faqFiveDesc')}</Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="5" className='w-100'>
                <Accordion.Header className='w-100 accordian-title py-2'>{localise('homepage.faqSixTitle')}</Accordion.Header>
                <Accordion.Body className='w-100 accordian-content-bg'>{localise('homepage.faqSixDesc')}</Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </div>
        </div>
      </Container>
    </div>
  )

  return (
    <div>
      <HeaderView/>
      <IntroView/>
      <MyServices/>
      <Testimonials/>
      <FAQs/>
    </div>
  )
}

export default HomepageView
